import React from "react";
import {
  Modal,
  Box,
  Typography,
  TextField,
  Grid,
  Button,
  useTheme,
  useMediaQuery,
} from "@mui/material";

const AddBankAccountModal = ({
  open,
  onClose,
  accountData,
  onChange,
  onSubmit,
  loading,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "#fff",
    boxShadow: 24,
    borderRadius: 2,
    width: isMobile ? "70%" : 400,
    p: isMobile ? 2 : 4,
    fontFamily: "'Poppins', sans-serif",
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={modalStyle}>
        <Typography
          variant="h6"
          fontWeight="bold"
          color="primary"
          align="center"
          fontSize="3rem"
          mb={3}
        >
          Add Account
        </Typography>

        <Grid container spacing={2}>
          {["accountNumber", "ifsc", "bankName", "branchName"].map(
            (field, i) => (
              <Grid item xs={6} key={field}>
                <TextField
                  required={i < 2}
                  label={
                    field === "accountNumber"
                      ? "Account Number"
                      : field.toUpperCase()
                  }
                  name={field}
                  fullWidth
                  value={accountData[field]}
                  onChange={onChange}
                  placeholder={`Enter your ${
                    field === "accountNumber" ? "Account Number" : field
                  }`}
                  InputLabelProps={{
                    sx: {
                      fontSize: "1.6rem",
                      fontWeight: 600,
                    },
                  }}
                  InputProps={{
                    sx: {
                      fontSize: "1.5rem",
                      "&::placeholder": {
                        fontSize: "2rem",
                        fontWeight: 600,
                        opacity: 0.7,
                      },
                    },
                  }}
                />
              </Grid>
            )
          )}
        </Grid>

        <Box mt={3} display="flex" justifyContent="flex-end" gap={2}>
          <Button
            variant="outlined"
            onClick={onClose}
            sx={{ fontSize: "1.6rem", fontWeight: 600 }}
          >
            Cancel
          </Button>

          <Button
            variant="contained"
            onClick={onSubmit}
            disabled={loading}
            sx={{ fontSize: "1.6rem", fontWeight: 600 }}
          >
            Submit
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default AddBankAccountModal;
